import { Component, OnInit, Input, Output, TemplateRef, ViewContainerRef, EventEmitter } from '@angular/core';
@Component({
    selector: 'app-dialog-header',
    templateUrl: './dialog-header.component.html',
    styleUrls: ['./dialog-header.component.css'],
    standalone: false
})
export class DialogHeaderComponent implements OnInit {
    @Input() template: TemplateRef<any>;
    @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
    constructor(private vcr: ViewContainerRef) {}

    ngOnInit() {
        this.vcr.createEmbeddedView(this.template);
        // this.dialogService.getHeaderEvent().subscribe((data)=>{
        //   this.onClick(data);
        // });
    }

    onClick(data) {
        this.clicked.emit(data);
    }
}
